//admincomponents/Customers.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './Customer.module.css';
import config from '../../config/config';

const Customers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  



  useEffect(() => {
    const fetchUsers = async () => {
      try {
       const res = await axios.get(`${config.apiBaseUrl}/api/users/all`);

        setUsers(res.data);
      } catch (error) {
        console.error('Failed to fetch users:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  if (loading) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>Customers List</h2>
        <div className={styles.emptyMessage}>Loading customers...</div>
      </div>
    );
  }

  const handleDelete = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) return;

    try {
      await axios.delete(`${config.apiBaseUrl}/api/users/${userId}`);
      setUsers(prevUsers => prevUsers.filter(user => user._id !== userId));
    } catch (error) {
      console.error('Failed to delete user:', error);
      alert('Failed to delete user');
    }
  };

 return (
  <div className={styles.container}>
    <h2 className={styles.title}>Customers List</h2>
    <div className={styles.totalUsers}>Total Users: {users.length}</div>
    
    <div className={styles.tableResponsive}>
      <table className={styles.table}>
        <thead className={styles.header}>
          <tr>
            <th className={`${styles.headerCell} ${styles.snCell}`}>SN</th>
            <th className={`${styles.headerCell} ${styles.usernameCell}`}>Username</th>
            <th className={`${styles.headerCell} ${styles.emailCell}`}>Email</th>
            <th className={`${styles.headerCell} ${styles.contactCell}`}>Contact</th>
            <th className={`${styles.headerCell} ${styles.cartCell}`}>Cart Items</th>
            <th className={`${styles.headerCell} ${styles.actionCell}`}>Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user, index) => (
            <tr key={user._id} className={`${styles.row} ${index % 2 === 0 ? styles.evenRow : ''}`}>
              <td className={`${styles.cell} ${styles.snCell}`}>{index + 1}</td>
              <td className={`${styles.cell} ${styles.usernameCell}`}>{user.username}</td>
              <td className={`${styles.cell} ${styles.emailCell}`}>{user.email}</td>
              <td className={`${styles.cell} ${styles.contactCell}`}>{user.contact || 'N/A'}</td>
              <td className={`${styles.cell} ${styles.cartCell}`}>
                <span className={styles.cartCount}>{user.cart?.length || 0}</span>
              </td>
              <td className={`${styles.cell} ${styles.actionCell}`}>
                <button className={styles.deleteButton} onClick={() => handleDelete(user._id)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {users.length === 0 && (
      <div className={styles.emptyMessage}>No customers found</div>
    )}
  </div>
);
};

export default Customers;